import { values } from '@fortem-monorepo/js-utilities';
export const AXE_FLAG = {
    Long: 'L',
    LongShort: 'LS',
    OtherRisk: 'OR',
    Short: 'S',
};
export const AXE_FLAGS = values(AXE_FLAG);
